import { getUA } from 'mobile-device-detect';
import { forkJoin, of } from 'rxjs';
import {
  catchError, map, switchMap,
} from 'rxjs/operators';
import { SsoApiUrl } from '@/config';
import store from '../store/index';
import sctService from '../services/sctService';
import ssoService from '../services/ssoService';
import mbcService from '../services/mbcService';
import mcsService from '../services/mcsService';

let storeUrlObservable = null;

export default {
  // 取得要被忽略的 Routes
  getIgnoreRoutes() {
    return ['redeemList', 'redeemDetail', 'invite'];
  },
  // 取得Cookie值
  getCookie(cookieName) {
    const name = `${cookieName}=`;
    const cookies = document.cookie.split(';');
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < cookies.length; i++) {
      const c = cookies[i].trim();
      if (c.indexOf(name) === 0) return c.substring(name.length, c.length);
    }
    return null;
  },
  // 設置Cookie
  setCookie(cookieName, cookieValue) {
    document.cookie = `${cookieName}=${cookieValue}; path=/`;
  },
  // 使Cookie失效
  deleteCookie(cookieName) {
    document.cookie = `${cookieName}=; path=/; expires=${Date.now()}`;
  },
  // 登入
  login(path, query) {
    let params = {
      companyid: store.state.companyId,
      membersourceid: store.state.memberSourceId,
    };

    if (query) params = Object.assign(params, query);
    const queryString = new URLSearchParams(params).toString();

    const redirectUrl = encodeURIComponent(encodeURIComponent(`${window.location.origin}${path}?${queryString}`));
    const ssoLoginUrl = `${SsoApiUrl}login?companyid=${store.state.companyId}&membersourceid=${store.state.memberSourceId}&redirect_url=${redirectUrl}`;

    // 以 line 瀏覽器、Liff 開啟
    if (getUA.match(/line/igm) || getUA.match(/liff/igm)) {
      // 跳轉至 SSO 綁定頁
      window.location.href = `${ssoLoginUrl}&linebind=1`;
    } else {
      // 跳轉至 SSO 登入頁
      window.location.href = ssoLoginUrl;
    }
  },
  toSBC(str) {
    let result = '';
    for (let index = 0; index < str.length; index += 1) {
      let cCode = str.charCodeAt(index);
      // 全形與半形相差（除空格外）：65248（十進位制）
      cCode = (cCode >= 0xFF01 && cCode <= 0xFF5E) ? (cCode - 65248) : cCode;
      // 處理空格
      cCode = (cCode === 0x03000) ? 0x0020 : cCode;
      result += String.fromCharCode(cCode);
    }
    return result;
  },
  // 以{min}~{max}為範圍產生亂數
  randomNum(min, max) {
    return Math.floor(Math.random() * (max - min) + min);
  },
  // 取得個人專屬雲店Url(取不到則取主店)
  getPersonalStoreUrl() {
    // 已經有完成的observable，直接回傳
    if (storeUrlObservable) { return storeUrlObservable; }

    const { accessToken, companyId } = store.state;
    let agentServiceId;
    // 取得主店
    const stores$ = sctService.getStores({ companyId });
    // 有token就換成code
    let code$;
    let personalStore$;
    if (accessToken) {
      // 取得用來登入的code
      code$ = ssoService.getNewCodeByAccesstoken({ accessToken });
      // 取得個人專屬雲店 => 先取得溝通群組標籤，再取得對應的專員服務代碼，最後取得對應的雲店Url
      personalStore$ = mbcService.getMemberTag({
        companyId,
        tagGroupType: 'ChatGroup',
      }, { accessToken })
        .pipe(
          switchMap((tagRes) => {
            if (!tagRes.response.success || tagRes.response.data[0].memberTag <= 0) { return of(null); }
            const { companyTagNo } = tagRes.response.data[0].memberTag[0];
            return mcsService.getAgentService({
              companyTagNo,
            });
          }),
          switchMap((agentRes) => {
            if (!agentRes || !agentRes.response.success || !agentRes.response.data[0]) { return of(null); }
            agentServiceId = agentRes.response.data[0].agentServiceId;

            return sctService.getStores({
              companyId,
              agentServiceId,
            });
          }),
          catchError(() => of(null)),
        );
    } else {
      code$ = of(null);
      personalStore$ = of(null);
    }

    return forkJoin({
      codeRes: code$,
      storesRes: stores$,
      personalStoreRes: personalStore$,
    }).pipe(
      map((res) => {
        const { codeRes, storesRes, personalStoreRes } = res;
        let storeUrl;

        // 嘗試取得個人專屬雲店資料；否則取得主店
        if (personalStoreRes && personalStoreRes.response.success) {
          storeUrl = new URL(personalStoreRes.response.data[0].url);
        } else {
          storeUrl = new URL(storesRes.response.data.find((x) => x.isMain && x.status === 2).url);
        }

        // 加上登入code
        if (codeRes && codeRes.response.success) {
          storeUrl.pathname = 'Plugins/SSOAuth/LoginCallback';
          storeUrl.search = new URLSearchParams({ code: codeRes.response.data[0].code });
        }
        // 設定一個只有結果的observable做回傳用
        storeUrlObservable = of(storeUrl.href);

        return storeUrl.href;
      }),
    );
  },
};
